import axios from "axios";

const breAxios = axios.create({
  // UAT-only: point BRE at the local core (was live prod lmsapi.saloracapital.com).
  baseURL: "http://localhost:8082",
  headers: {
    "Content-Type": "application/json",
  },
});

// 🚫 ensure token kabhi attach na ho f
breAxios.interceptors.request.use(config => {
  delete config.headers.Authorization;
  return config;
});

export default breAxios;